/* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomInput,
  CustomModal,
  CustomTextArea,
  GrowerDetailCard,
} from "#components";
import ImagesUrl from "#constants/images.js";
import useGet from "#hooks/useGet.js";
import { WebLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import React, { useEffect, useRef, useState } from "react";
import ReactSelector from "../../components/ReactSelector";
import { useFormik } from "formik";
import { fieldInitialValues } from "#validations/initialValues.js";
import { fieldValidationSchema } from "#validations/validationSchema.js";
import toast from "react-hot-toast";
import usePost from "#hooks/usePost.js";
import FieldListing from "./fieldListing";
import CustomAlert from "../../components/CustomAlert";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";
import useDelete from "#hooks/useDelete.js";
import usePut from "#hooks/usePut.js";
import { useLocation } from "react-router-dom";
import { numberOnly } from "#utils/helpers.js";
import globalConfig from "#constants/globalConfig.js";

const FieldManagement = () => {
  const location = useLocation();
  const growerByLocation = location.state?.key || {};
  const [dataCount, setDataCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [growerId, setGrowerId] = useState(null);
  const [fieldDetail, setFieldDetail] = useState(null);
  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });

  const [expandedRow, setExpandedRow] = useState(null);
  const inputRefs = useRef([]);

  const { data: growerListData, isLoading: isGrowerLoading } = useGet(
    ENDPOINTS.GROWER_LIST_FIELD,
    QUERY_KEYS.GROWER_LIST_FIELD_QUERY_KEY
  );
  const { mutateAsync: editFieldMutateAsync, isLoading: isLoadingEditField } =
    usePut(ENDPOINTS.EDIT_FIELD, QUERY_KEYS.EDIT_FIELD_QUERY_KEY);
  const { data: cropListData, isLoading: isCropLoading } = useGet(
    ENDPOINTS.CROP_LIST,
    QUERY_KEYS.CROP_LIST_QUERY_KEY
  );
  const { mutateAsync: addFieldMutateAsync, isLoading: isLoadingAddField } =
    usePost(ENDPOINTS.ADD_FIELD, QUERY_KEYS.ADD_FIELD_QUERY_KEY);
  const {
    mutateAsync: deleteFieldMutateAsync,
    isLoading: isLoadingDeleteField,
  } = useDelete(ENDPOINTS.DELETE_FIELD, QUERY_KEYS.DELETE_FIELD_QUERY_KEY);

  const customValidate = (values) => {
    const errors = {};
    if (!values.SubFields || values.SubFields.length === 0) {
      errors.cropId = "Crop is required";
    }
    if (values.cropId) {
      delete errors.cropId;
    }
    return errors;
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: fieldInitialValues,
    validationSchema: fieldValidationSchema,
    // validate: customValidate,

    onSubmit: async (value) => {
      const addData = {
        growerId: growerId?.id,
        name: values?.fieldName,
        area: values?.acres,
        lld1: values?.LLD[0] || "",
        lld2: values?.LLD[1] || "",
        lld3: values?.LLD[2] || "",
        lld4: values?.LLD[3] || "",
        lld5: values?.LLD[4] || "",
        lld6: values?.LLD[5] || "",
        notes: values?.notes,
        cropId: values?.cropId?.id,
        subField: values?.SubFields?.map((subField) => ({
          name: subField.name,
          cropId: subField.cropId?.id,
        })),
      };
      const editData = {
        fieldId: fieldDetail?._id,
        name: values?.fieldName,
        area: values?.acres,
        lld1: values?.LLD[0] || "",
        lld2: values?.LLD[1] || "",
        lld3: values?.LLD[2] || "",
        lld4: values?.LLD[3] || "",
        lld5: values?.LLD[4] || "",
        lld6: values?.LLD[5] || "",
        notes: values?.notes,
        cropId: values?.cropId?.id,
        deletedSubFields: value.RemoveSubFields,
        subField: values?.SubFields?.map((subField) => ({
          subFieldId: subField._id || "",
          name: subField.name,
          cropId: subField.cropId?.id,
        })),
      };

      if (open.add) {
        try {
          const response = await addFieldMutateAsync(addData);
          AlertTost(response?.message, "success");
          resetForm();
          onClose("add");
        } catch (error) {
          toast.dismiss();
          AlertTost(error?.response?.data?.message, "error");
        }
      } else {
        try {
          const response = await editFieldMutateAsync(editData);
          AlertTost(response?.message, "success");
          resetForm();
          onClose("edit");
        } catch (error) {
          toast.dismiss();
          AlertTost(error?.response?.data?.message, "error");
        }
      }
    },
  });

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const onOpen = (key, data) => {
    setOpen({ ...open, [key]: true });

    setFieldDetail(data);
  };
  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setFieldDetail(null);
    resetForm();
  };
  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };
  // Pagination functions

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((nextPage) => nextPage + 1);
  };
  // Grower Options
  const growerOptions = growerListData?.data?.map((item) => ({
    id: item?._id,
    value: item?._id,
    label: `${item?.firstName} ${item?.lastName}`,
  }));

  // Crop Options
  const cropOptions = cropListData?.data?.map((item) => ({
    id: item?._id,
    value: item?._id,
    label: item?.name,
  }));

  const removeSelectedCrop = (id) => {
    setFieldValue("cropId", null);
    setFieldValue("RemoveSubFields", [id]);
  };

  // SubField
  const addSubField = () => {
    setFieldValue("SubFields", [
      ...values.SubFields,
      { name: "", cropId: null },
    ]);
  };

  const removeSubField = (index, id) => {
    const updatedSubFields = values.SubFields.filter((_, i) => i !== index);
    const updatedRemoveSubFields = Array.isArray(values.RemoveSubFields)
      ? [...values.RemoveSubFields, id]
      : [id];
    setFieldValue("SubFields", updatedSubFields);
    setFieldValue("RemoveSubFields", updatedRemoveSubFields);
  };

  const handleInputChange = (event, index) => {
    const updatedLLD = [...values.LLD];
    updatedLLD[index] = event.target.value.trim();
    const filteredLLD = updatedLLD.filter((value) => value !== "");
    setValues({
      ...values,
      LLD: filteredLLD,
    });
  };

  const handleFocusChange = (event, index) => {
    if (event.target.value.length === 2 && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleDeleteField = async (fieldId) => {
    CustomAlert({
      title: "Are you sure you want to delete the Field?",
      confirmButtonText: isLoadingDeleteField ? (
        <ClipLoader size={17} color="#fff" />
      ) : (
        "Confirm"
      ),
      icon: "question",
      onConfirm: async () => {
        try {
          const response = await deleteFieldMutateAsync({
            fieldId: fieldId,
          });
          AlertTost(response?.message, "success");
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  // Function to filter by cropByID
  const filterCropById = (cropId) => {
    return cropOptions?.find((option) => option.id === cropId) || null;
  };

  // Function to filter by cropByID
  const filterGrowerById = (growerId) => {
    setGrowerId(
      growerOptions?.find((option) => option.id === growerId) || null
    );
    return growerOptions?.find((option) => option.id === growerId) || null;
  };

  const renderFieldComponent = () => {
    if (growerId) {
      return (
        <dv>
          <GrowerDetailCard GrowerId={growerId?.id} />
          <FieldListing
            growerId={growerId}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dataCount={dataCount}
            expandedRow={expandedRow}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
            onDataCountChange={onDataCountChange}
            onOpen={onOpen}
            toggleRow={toggleRow}
            handleDeleteField={handleDeleteField}
          />
        </dv>
      );
    }
  };

  useEffect(() => {
    if (growerByLocation) {
      filterGrowerById(growerByLocation);
    }
  }, []);

  useEffect(() => {
    const subFieldData = fieldDetail?.subFields?.map((subField) => {
      const selectedCrop = filterCropById(subField?.cropId);
      return {
        _id: subField?._id,
        name: subField?.name,
        cropId: selectedCrop || null,
      };
    });
    if (open.edit) {
      setValues({
        fieldName: fieldDetail?.name,
        acres: fieldDetail?.area,
        cropId: filterCropById(fieldDetail?.cropId),
        LLD: [
          fieldDetail?.lld1,
          fieldDetail?.lld2,
          fieldDetail?.lld3,
          fieldDetail?.lld4,
          fieldDetail?.lld5,
          fieldDetail?.lld6,
        ],
        notes: fieldDetail?.notes,
        SubFields: subFieldData || [],
      });
    }
  }, [open.edit, fieldDetail]);

  return (
    <WebLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="wrapper-card">
            <div className="row">
              <div className="col-xl-12">
                <form>
                  <div className="row justify-content-between g-3">
                    <div className="col-xl-6">
                      <div className="filter-wrapper">
                        <ReactSelector
                          options={growerOptions}
                          placeholder="Select grower"
                          labelDisabled={true}
                          value={growerId}
                          errorDisabled={true}
                          isLoading={isGrowerLoading}
                          onChange={(value) => {
                            setGrowerId(value);
                            localStorage.setItem(
                              globalConfig.GROWER_ID,
                              JSON.stringify(value?.id)
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {renderFieldComponent()}
        </div>
      </section>
      {/* add new Field modal */}
      <CustomModal
        open={open.add || open.edit}
        title={open.add ? "Add New Field" : "Edit Field"}
        actionButtonTitle={open.add ? "Save" : "Update"}
        onClose={() => onClose(open.add ? "add" : "edit")}
        onSubmit={() => {
          handleSubmit();
        }}
        loading={isLoadingAddField || isLoadingEditField}
        bodyClass="modal-body p-0 border_structure"
      >
        <div className="common-modal-form">
          <div className="row gy-4">
            <div className="col-lg-6">
              <CustomInput
                star="true"
                label="Field Name"
                type="text"
                name="fieldName"
                placeholder="Enter your field name"
                value={values.fieldName}
                error={errors.fieldName}
                touched={touched.fieldName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                star="true"
                label="Acres"
                type="text"
                name="acres"
                placeholder="Enter your acres"
                value={values.acres}
                error={errors.acres}
                touched={touched.acres}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyPress={numberOnly}
              />
            </div>
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <label>Legal Land Description (LLD)</label>
                  <span className="text-danger">*</span>
                  <div className="d-flex gap-3">
                    {[0, 1, 2, 3, 4].map((index) => (
                      <input
                        key={index}
                        className="legal-wrap"
                        maxLength={2}
                        value={values.LLD[index]}
                        ref={(el) => (inputRefs.current[index] = el)}
                        onChange={(event) => handleInputChange(event, index)}
                        // onKeyUp={(event) => handleFocusChange(event, index)}
                      />
                    ))}
                  </div>
                  {touched.LLD && errors.LLD && (
                    <p style={{ color: "red", marginBottom: 0 }}>
                      {errors.LLD}
                    </p>
                  )}
                </div>
                <div className="col-lg-12">
                  <CustomTextArea
                    placeholder="Notes......."
                    error={errors.notes}
                    value={values.notes}
                    onChange={handleChange}
                    name="notes"
                    onBlur={handleBlur}
                    touched={errors.notes}
                  />
                </div>
                {/* {values?.SubFields?.length > 0 ? null : (
                  <div className="col-lg-12  mt-4">
                    {values?.cropId ? (
                      <div className="file_preview_item">
                        <div className="file_item_title">
                          {values?.cropId?.label}
                        </div>
                        <button
                          className="remove_file"
                          onClick={() =>
                            removeSelectedCrop(fieldDetail?.subfieldId)
                          }
                        >
                          <img src={ImagesUrl.deleteIcon} alt="Trash" />
                        </button>
                      </div>
                    ) : (
                      <ReactSelector
                        label="Crop"
                        options={cropOptions}
                        name="cropId"
                        placeholder="Select"
                        value={values?.cropId}
                        isLoading={isCropLoading}
                        onChange={(value) => {
                          setFieldValue("cropId", value);
                          setFieldValue("SubFields", []);
                        }}
                        error={touched.cropId && errors.cropId}
                        onBlur={handleBlur}
                        touched={touched.cropId}
                      />
                    )}
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
        {/* {values.cropId ? null : (
          <div className="sub-files-wrapper">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="mt-0 mb-3"> Add Sub Fields</h3>
              </div>
            </div>
            <div className="add_sub_fields_blk">
              {values?.SubFields?.map((subField, index) => {
                return (
                  <div className="sub_fields_wrapper">
                    <div className="sub_fields_blk">
                      <div className="sub_fields_item">
                        <CustomInput
                          label="Sub Field Name"
                          type="text"
                          name={`SubFields[${index}].name`}
                          placeholder="Enter your sub field name"
                          value={subField.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors?.SubFields?.[index]?.name}
                          touched={touched?.SubFields?.[index]?.name}
                        />
                      </div>
                      <div className="sub_fields_item">
                        <CustomInput
                          label="Sub Field Name"
                          type="text"
                          name={`SubFields[${index}].name`}
                          placeholder="Enter your sub field name"
                          value={subField.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors?.SubFields?.[index]?.name}
                          touched={touched?.SubFields?.[index]?.name}
                        />
                      </div>

                      <ReactSelector
                        label="Crop"
                        customClass={"col-lg-4"}
                        options={cropOptions}
                        placeholder="Select"
                        value={subField.cropId}
                        isLoading={isCropLoading}
                        onChange={(value) => {
                          setFieldValue(`SubFields[${index}].cropId`, value);
                        }}
                        error={errors?.SubFields?.[index]?.cropId}
                        onBlur={handleBlur}
                        touched={touched?.SubFields?.[index]?.cropId}
                      />
                    </div>
                    <div className="delete_item_action_blk d-flex">
                      <button className="border-0 bg-white">
                        <img
                          src={ImagesUrl.deleteIcon}
                          alt="delete-icon"
                          onClick={() => removeSubField(index, subField?._id)}
                        />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div>
              <button className="outline_btn_style" onClick={addSubField}>
                + Add more
              </button>
            </div>
          </div>
        )} */}
      </CustomModal>
    </WebLayout>
  );
};

export default FieldManagement;
